"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToCartCB = exports.addToCart = exports.cartAdd = void 0;
var queue_1 = require("./queue");
var events_1 = require("./events");
var jquery_1 = require("../jquery");
;
;
var cartAdd = function (params) {
    return new Promise(function (resolve, reject) {
        var o = {
            url: '/cart/add.js',
            dataType: "json",
            method: 'POST',
            data: params,
            action: 'add'
        };
        o.success = function (data) {
            resolve(data);
            (0, queue_1.addFinishTrigger)({ event: events_1.ON_ITEM_ADDED, data: data });
            (0, queue_1.removeTask)(this);
            (0, queue_1.nextTask)();
        }.bind(o);
        o.error = function (e, i, a) {
            reject(e ? e.responseJSON || e : 'Unknown Error');
            (0, queue_1.removeTask)(this);
            (0, queue_1.errorQueue)();
        }.bind(o);
        o.task = function () {
            jquery_1.jq.ajax(this);
        }.bind(o);
        (0, queue_1.addTask)(o);
    });
};
exports.cartAdd = cartAdd;
//Promise Flavour
/** @deprecated */
var addToCart = function (variant, quantity, properties) {
    if (quantity === void 0) { quantity = 1; }
    return new Promise(function (resolve, reject) {
        (0, exports.addToCartCB)(variant, quantity, properties, resolve, reject);
    });
};
exports.addToCart = addToCart;
//Callback flavour
/** @deprecated */
var addToCartCB = function (variant, quantity, properties, callback, errorCallback) {
    if (quantity === void 0) { quantity = 1; }
    var o = {
        variant: variant,
        quantity: quantity,
        callback: callback,
        errorCallback: errorCallback,
        url: '/cart/add.js',
        dataType: "json",
        method: 'POST',
        data: {
            id: variant,
            quantity: quantity,
            properties: properties
        },
        action: 'add'
    };
    o.success = function (data) {
        if (this.callback)
            this.callback(data);
        (0, queue_1.addFinishTrigger)({ event: events_1.ON_ITEM_ADDED, data: data });
        (0, queue_1.removeTask)(this);
        (0, queue_1.nextTask)();
    }.bind(o);
    o.error = function (e, i, a) {
        if (typeof this.errorCallback === "function") {
            this.errorCallback(e ? e.responseJSON || e : 'Unknown Error');
        }
        (0, queue_1.removeTask)(this);
        (0, queue_1.errorQueue)();
    }.bind(o);
    o.task = function () {
        jquery_1.jq.ajax(this);
    }.bind(o);
    (0, queue_1.addTask)(o);
};
exports.addToCartCB = addToCartCB;
//# sourceMappingURL=add.js.map